import React from 'react';
import styles from './ChildCard.module.css';
import ChildInfoOnCard from './ChildInfoOnCard';
import GlassCard from '../customs/GlassCard';

const ChildCard = ({ child, isSelected, onToggle }) => {
  return (
    <GlassCard
      className={isSelected ? styles.selected : styles.card}
      onClick={onToggle}
    >
      <ChildInfoOnCard child={child} />
    </GlassCard>
  );
};

export default ChildCard;
